import { getToken, returnError } from './helperFunc';
import { fetchOfflineLogsAction, allMachinesOfflineLogAction } from './requestEndpoints';

const SET_OFFLINE_LOADING = 'SET_OFFLINE_LOADING';
const CLEAR_OFFLINE_ERROR = 'CLEAR_OFFLINE_ERROR';

const OFFLINE_LOGS_SUCCESS = 'OFFLINE_LOGS_SUCCESS';
const OFFLINE_LOGS_FAIL = 'OFFLINE_LOGS_FAIL';

const SET_OFFLINE_MACHINES_LOADING = 'SET_OFFLINE_MACHINES_LOADING';
const OFFLINE_MACHINES_SUCCESS = 'OFFLINE_MACHINES_SUCCESS';
const OFFLINE_MACHINES_FAIL = 'OFFLINE_MACHINES_FAIL';

const initialState = {
    loading: false,
    error: null,
    logs: [],
    machinesLoading: false,
    machines: [],
};

export const offlineDashboardReducer = (state = initialState, action) => {
    const { type, payload } = action || {};
    switch (type) {
        case SET_OFFLINE_LOADING:
            return { ...state, loading: true, error: null };
        case CLEAR_OFFLINE_ERROR:
            return { ...state, error: null };
        case OFFLINE_LOGS_SUCCESS:
            return { ...state, loading: false, logs: payload?.data || [] };
        case OFFLINE_LOGS_FAIL:
            return { ...state, loading: false, error: payload };
        case SET_OFFLINE_MACHINES_LOADING:
            return { ...state, machinesLoading: true, error: null };
        case OFFLINE_MACHINES_SUCCESS:
            return { ...state, machinesLoading: false, machines: payload?.data || [] };
        case OFFLINE_MACHINES_FAIL:
            return { ...state, machinesLoading: false, error: payload };
        default:
            return state;
    }
};

export const fetchOfflineLogs = (reqBody) => async (dispatch, getState) => {
    try {
        dispatch({ type: CLEAR_OFFLINE_ERROR });
        dispatch({ type: SET_OFFLINE_LOADING });

        const { user } = getState();
        const token = getToken(user);

        const { data } = await fetchOfflineLogsAction(reqBody || {}, token);
        dispatch({ type: OFFLINE_LOGS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: OFFLINE_LOGS_FAIL, payload: returnError(error) });
    }
};

export const allMachinesOfflineLog = (operatorId, outletId) => async (dispatch, getState) => {
    try {
        dispatch({ type: CLEAR_OFFLINE_ERROR });
        dispatch({ type: SET_OFFLINE_MACHINES_LOADING });

        const { user } = getState();
        const token = getToken(user);

        const { data } = await allMachinesOfflineLogAction(operatorId, outletId, token);
        dispatch({ type: OFFLINE_MACHINES_SUCCESS, payload: data });
    } catch (error) {
        dispatch({ type: OFFLINE_MACHINES_FAIL, payload: returnError(error) });
    }
};

export default offlineDashboardReducer;